import React, { forwardRef } from 'react'
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Link as RouterLink, useHistory } from 'react-router-dom';
// import { NavLink } from "react-router-dom";

import { List, ListItem, Typography } from '@material-ui/core';

import ListGeneratorOuter from './ListGeneratorOuter'

const useStyles = makeStyles(theme => ({
    title: {
        paddingLeft: theme.spacing(1)
    },
    listItem: {
        borderRadius: 6,
        margin: '6px 0px'
    },
    listItemActive: {
        borderRadius: 6,
        margin: '6px 0px',
        background: theme.palette.primary.light
    }
}))

//----
//custom router
const CustomRouterLink = forwardRef((props, ref) => (
    <div
        ref={ref}
    //style={{backgroundColor:'red'}}
    >
        <RouterLink {...props} />
    </div>
));
//---

function SideBarNavigation(props) {
    const { pages, className, ...rest } = props
    const classes = useStyles()
    const history = useHistory();


    const handleClick = (page) => {
        console.log("handleClick")
    };

    //route match
    const getmatch = (to) => {
        console.log("....",window.location.pathname , to);
        const match = window.location.pathname === to
        return match
        //return match? 'yes': 'no'
    }

    const navChange = (href) => {
        history.push(href)
    }



    const renderMenuLevels = data => {
        return data.map((page, index) => {
            if (page.child) {
                return (
                    <ListGeneratorOuter page={page} keyNo={`${page.href}_`} key={`${page.href}_`}>
                        {renderMenuLevels(page.child)}
                    </ListGeneratorOuter>
                )
            }
            else {
                return (
                    <ListItem
                        key={`${page.href}_in`}
                        button
                        className={getmatch(page.href) ? classes.listItemActive : classes.listItem}
                        //className={classes.listItem}
                        component={CustomRouterLink}
                        to={page.href}
                        //onClick={()=>navChange(page.href)}
                    >
                        {page.icon}
                        <Typography variant="h5" className={classes.title}>{page.title}</Typography>
                    </ListItem>

                )
            }
        })
    }

    return (

        <List >{renderMenuLevels(pages)}</List>
    )
}

export default SideBarNavigation
SideBarNavigation.propTypes = {
    pages: PropTypes.array.isRequired,
    className: PropTypes.string
}